import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";

import AccountChangeFoto from '../AccountChangeFoto/AccountChangeFoto';

import { addToFavorites, deleteFromFavorites, requestFromManager, requestFromManagerbyContent } from '../../store/favorites/actions';

import Svg from "../../assets/icons/icons";
import { colors } from "../../styles/variables.js"

import {
  PprojectImageStyled,
  PprojectWrapEmailStyled,
  PprojectEmailStyled
} from '../Tabs/style.js';

import {
  CardStyled,
  CardImageStyled,
  CardWrapStyled,
  CardTextStyled,
  CardsmallTextStyled
} from '../TabsCardEvents/style.js';

import {
  PprojectSt,
  WpapImgSt,
  DateSt,
  LeftProfileProjectSt,
  ItemProjectSt,
  IconFavoritesSt,
  IconWrapFavoritesSt,
  TooltipSt,
  TooltipItemSt
} from './style.js';

import i18n from "i18next";

const TabsLeft = ({ managers, textSend, type, tabs, imgPoster, id, typeBookmark, isInFavourites }) => {
  const [bookmarkFavorites, setBookmarkFavorites] = useState(false);
  const [bookmarkCheck, setBookmarkCheck] = useState("not");
  const [sendRequest, setSendRequest] = useState(false);

  const dispatch = useDispatch();
  const projects = useSelector((store) => store.projects.projects);
  const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
  const token = useSelector((store) => store.auth.dataToken.token);
  const photo = useSelector((store) => store.customer.customer.photo);
  const dop = useSelector((store) => store.dop.projects);
  const query = useSelector((store) => store.query.projects);
  const favoritesMessage = useSelector((store) => store.favorites.message);

  const timers = useRef([]);
  useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

  // componentDidUpdate: всплывающее окно для кнопок
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setSendRequest(favoritesMessage[0] === true ? "Запрос отправлен" : "Запрос уже существует");
    timers.current.push(setTimeout(() => {
      setSendRequest(false);
    }, 1500));
  }, [favoritesMessage]);

  // обработка клика на закладку
  const _bookmark = (ids, favType) => {
    if (bookmarkCheck === "not") {
      // при первом клике отталкиваемся от значения, пришедшего с сервера
      const current = isInFavourites;
      if (current) {
        dispatch(deleteFromFavorites(ids, favType, token));
      } else {
        dispatch(addToFavorites(ids, favType, token));
      }
      setBookmarkFavorites(!current);
      setBookmarkCheck("check");
    }
    else if (bookmarkCheck === "check") {
      if (bookmarkFavorites) {
        dispatch(deleteFromFavorites(ids, favType, token));
      } else {
        dispatch(addToFavorites(ids, favType, token));
      }
      setBookmarkFavorites((prev) => !prev);
    }
  };

  const favorietsColor = bookmarkCheck === "check" ? bookmarkFavorites : isInFavourites

  //для "запросы"
  const allQuery = query?.all_count;
  const providedQuery = query?.provided_count;
  const inProgressQuery = query?.in_progress_count;
  const requestQuery = query?.request_count;

  //для доп.материалы
  const allDop = dop?.all_count;
  const provided = dop?.provided_count;
  const request = dop?.request_count;

  const date = new Date();
  const today = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

  return (
    <>
      {type !== "profile" &&
        <WpapImgSt>
          <PprojectImageStyled src={imgPoster ? imgPoster : photo} width="300" height="425" className={type === "profile" && "profile"}></PprojectImageStyled>
          {type !== "event" && isLoggedIn &&
            //кнопки для запроса контента
            <>
              <PprojectWrapEmailStyled>
                <Svg width="24" height="24" type="mail_outline" color={colors.blue_active}></Svg>
                <PprojectEmailStyled onClick={() => dispatch(requestFromManagerbyContent([id], token))}>запросить контент</PprojectEmailStyled>
                {/*всплывающее окно*/}
                {sendRequest &&
                  <TooltipSt className="bottom">
                    <TooltipItemSt>{sendRequest}</TooltipItemSt>
                  </TooltipSt>
                }
              </PprojectWrapEmailStyled>
              <PprojectWrapEmailStyled>
                <Svg width="24" height="24" type="add" color={colors.blue_active}></Svg>
                <PprojectEmailStyled onClick={() => dispatch(requestFromManager([id], token))}>запросить доп. материалы</PprojectEmailStyled>
              </PprojectWrapEmailStyled>
            </>
          }
          {type === "event" &&
            <PprojectWrapEmailStyled>
              <Svg width="24" height="24" type="mail_outline" color={colors.blue_active}></Svg>
              <PprojectEmailStyled href="mailto:content@sales.gpm-rtv.ru">{textSend}</PprojectEmailStyled>
            </PprojectWrapEmailStyled>
          }
          {isLoggedIn && (
            <IconWrapFavoritesSt onClick={() => _bookmark([id], typeBookmark)} >
              <IconFavoritesSt>
                <Svg width="24" height="24" type={favorietsColor ? "bookmark" : "bookmark_border"} color={colors.white} fill="white"></Svg>
              </IconFavoritesSt>
            </IconWrapFavoritesSt>
          )}
        </WpapImgSt>
      }

      {type === "profile" && tabs === 0 &&
        <>
          <AccountChangeFoto imgPoster={imgPoster}></AccountChangeFoto>

          <PprojectSt>
            {managers.length !== 0 && <h4 className="profile"> {i18n.t(`profile.your_manager`)}</h4>}
            {managers.map((item, i) => {
              return (
                <CardStyled className="profile" key={i}>
                  {item.photo && <CardImageStyled src={item.photo} width="200" height="283" className="profile"></CardImageStyled>}
                  <CardWrapStyled>
                    <CardTextStyled><h4>{item.full_name}</h4></CardTextStyled>
                    <CardsmallTextStyled>{item.position}</CardsmallTextStyled>
                    <PprojectWrapEmailStyled>
                      <Svg width="24" height="24" type="mail_outline" color={colors.blue_active}></Svg>
                      <PprojectEmailStyled href={"mailto:" + item.email}>{item.email}</PprojectEmailStyled>
                    </PprojectWrapEmailStyled>
                  </CardWrapStyled>
                </CardStyled>
              )
            })}
          </PprojectSt>
        </>
      }

      {type === "profile" && tabs === 1 &&
        <LeftProfileProjectSt>
          <DateSt>
            <span>{today}</span><br /><br />
          </DateSt>
          <ItemProjectSt colors={colors.black_text} className="all">
            <h4>{i18n.t(`profile.total_projects`)}: {projects.all_count ? projects.all_count : 0}</h4><br />
          </ItemProjectSt>
          {projects.active_count && <ItemProjectSt colors={colors.black_text}>
            <span>{i18n.t(`profile.active`)}: {projects.active_count ? projects.active_count : 0}</span><br /><br />
          </ItemProjectSt>}

          {projects.renewal_count && <ItemProjectSt colors={colors.magenta}>
            <span>{i18n.t(`profile.on_extension`)}: {projects.renewal_count ? projects.renewal_count : 0}</span><br /><br />
          </ItemProjectSt>}

          {projects.expired_count && <ItemProjectSt colors={colors.grey_text}>
            <span>{i18n.t(`profile.license_expired`)}: {projects.expired_count ? projects.expired_count : 0}</span><br /><br />
          </ItemProjectSt>}
        </LeftProfileProjectSt>
      }

      {type === "profile" && tabs === 2 &&
        <LeftProfileProjectSt>
          <DateSt>
            <span>{today}</span><br /><br />
          </DateSt>

          <ItemProjectSt colors={colors.black_text} className="all">
            <h4>{i18n.t(`profile.total_projects`)}: {allQuery ? allQuery : 0} </h4><br />
          </ItemProjectSt>

          <ItemProjectSt colors={colors.black_text}>
            <span>{i18n.t(`profile.received`)}: {providedQuery ? providedQuery : 0}</span><br /><br />
          </ItemProjectSt>

          <ItemProjectSt colors={colors.aqua}>
            <span>{i18n.t(`profile.In_work`)}: {inProgressQuery ? inProgressQuery : 0}</span><br /><br />
          </ItemProjectSt>

          <ItemProjectSt colors={colors.magenta}>
            <span>{i18n.t(`profile.in_processing`)}: {requestQuery ? requestQuery : 0}</span><br /><br />
          </ItemProjectSt>

        </LeftProfileProjectSt>
      }

      {type === "profile" && tabs === 3 &&
        <LeftProfileProjectSt>
          <DateSt>
            <span>{today}</span><br /><br />
          </DateSt>

          <ItemProjectSt colors={colors.black_text} className="all">
            <h4>{i18n.t(`profile.total_projects`)}: {allDop ? allDop : 0} </h4><br />
          </ItemProjectSt>

          <ItemProjectSt colors={colors.black_text}>
            <span>{i18n.t(`profile.received`)}: {provided ? provided : 0}</span><br /><br />
          </ItemProjectSt>

          <ItemProjectSt colors={colors.magenta}>
            <span>{i18n.t(`profile.in_processing`)}: {request ? request : 0}</span><br /><br />
          </ItemProjectSt>

        </LeftProfileProjectSt>
      }
    </>
  );
};

export default TabsLeft;
